export const SpinningBackground = () => (
    <div className="-z-30 absolute inset-0 flex max-h-screen items-center justify-center overflow-hidden">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
            className="min-h-[1000px] min-w-[1000px] animate-spin-slow md:min-h-[1200px] md:min-w-[1200px]"
            src="/svg/circle.svg"
            alt="background circle"
        />

        <div className="absolute inset-x-0 bottom-0 h-full bg-linear-to-t from-10% from-black to-black/40" />
        <div className="absolute inset-0 backdrop-blur-[3px]" />
    </div>
);
